export default {
  meta: {
    title: $localize`:@@meta.provably_fair.overview.title:Честная игра → CSFAIL`,
    description: $localize`:@@meta.provably_fair.overview.description:Честная игра от CSFAIL - это прозрачная система, подразумевающая влияние ставок игроков на результат раунда любого игрового режима!`
  }
};